import { Ride } from '@geovelo-frontends/commons';
import { Add } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

import successImg from '../../assets/images/success.svg';
import Button from '../../components/button';
import RideRecap from '../../components/ride-recap';

function Data({
  ride,
  isOwner,
  setRide,
}: {
  isOwner: boolean;
  ride: Ride | undefined;
  setRide: (ride: Ride) => void;
}): React.JSX.Element {
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  const completedData = ride
    ? [ride.photos.length > 0, ride.description, ride.steps.length > 0].filter(Boolean).length
    : undefined;

  return (
    <>
      <RideRecap isOwner={isOwner} ride={ride} setRide={setRide} />
      {isOwner &&
        ride &&
        ride.privacy === 'public' &&
        completedData !== undefined &&
        completedData !== 3 && (
          <Box
            alignItems="flex-start"
            borderRadius={2}
            display="flex"
            flexDirection="column"
            gap={1}
            padding={2}
            sx={{ backgroundColor: '#f3f7fd' }}
          >
            <img height={64} src={successImg} />
            <Typography fontWeight={600}>
              {t('geovelo.rides.detail.completion_card.title')}
            </Typography>
            <Typography variant="body2">
              {t('geovelo.rides.detail.completion_card.description')}
            </Typography>
            <Box alignItems="center" alignSelf="stretch" display="flex" gap={2}>
              <Box
                borderRadius={1}
                flexGrow={1}
                height={8}
                overflow="hidden"
                position="relative"
                sx={{ backgroundColor: '#c0c7cc' }}
              >
                <Box
                  borderRadius={1}
                  height={8}
                  left={0}
                  position="absolute"
                  sx={({ palette }) => ({ backgroundColor: palette.primary.main })}
                  top={0}
                  width={`${((completedData + 1) / 4) * 100}%`}
                />
              </Box>
              <Box flexShrink={0}>
                <Typography noWrap variant="body2">
                  {completedData + 1} / 4
                </Typography>
              </Box>
            </Box>
            {ride.photos.length === 0 && (
              <Button
                color="primary"
                component={Link}
                size="small"
                startIcon={<Add />}
                to={`/${currentLanguage}/ride-update/${ride.id}`}
                variant="outlined"
              >
                {t('geovelo.rides.detail.completion_card.actions.add_photo')}
              </Button>
            )}
            {!ride.description && (
              <Button
                color="primary"
                component={Link}
                size="small"
                startIcon={<Add />}
                to={`/${currentLanguage}/ride-update/${ride.id}`}
                variant="outlined"
              >
                {t('geovelo.rides.detail.completion_card.actions.add_description')}
              </Button>
            )}
            {ride.steps.length === 0 && (
              <Button
                color="primary"
                component={Link}
                size="small"
                startIcon={<Add />}
                to={`/${currentLanguage}/ride-update/${ride.id}?tab=steps`}
                variant="outlined"
              >
                {t('geovelo.rides.detail.completion_card.actions.add_steps')}
              </Button>
            )}
          </Box>
        )}
    </>
  );
}

export default Data;
